import { makeStyles } from "tss-react/mui";

import { Box, Card, CardHeader, Typography } from "@mui/material";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles()((theme: Theme) => ({
    card: {
        overflow: "hidden",
        boxShadow: "none",
        border: `1px solid ${theme.palette.emteria.border.primary}`,
        borderRadius: theme.spacing(2),

        "& .MuiListItem-root > .MuiTypography-root": {
            fontWeight: 600,
        },
    },
    header: {
        backgroundColor: theme.palette.emteria.background.cardHeader,
        color: theme.palette.emteria.link,
        minHeight: 72,
        alignItems: "center",
        boxSizing: "border-box",
    },
    headerBox: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    headerButtonBox: { display: "flex", gap: theme.spacing(1) },
}));

type SettingsCardProps = {
    title: React.ReactNode;
    action?: React.ReactNode;
    children: React.ReactNode;
};

export const SettingsCard = ({ title, action, children }: SettingsCardProps) => {
    const { classes } = useStyles();

    return (
        <Card className={classes.card}>
            <CardHeader
                className={classes.header}
                title={
                    <Box className={classes.headerBox}>
                        <Typography variant="h6" component="span" fontWeight={600}>
                            {title}
                        </Typography>
                        {action ? <div className={classes.headerButtonBox}>{action}</div> : null}
                    </Box>
                }
            />
            {children}
        </Card>
    );
};
